import React from 'react';
import { useTracks } from '../hooks/useTracks';
import { findTrackByName } from '../data/defaultTracks';

interface TrackBadgeProps {
  track: string;
  size?: 'small' | 'medium' | 'large';
}

const TrackBadge: React.FC<TrackBadgeProps> = ({ track, size = 'medium' }) => {
  const tracks = useTracks();
  const trackInfo = findTrackByName(tracks, track);

  const sizeClass =
    size === 'small'
      ? 'track-badge-sm'
      : size === 'large'
      ? 'track-badge-lg'
      : 'track-badge-md';

  return (
    <span
      className={`track-badge ${sizeClass}`}
      style={{ backgroundColor: trackInfo.color, color: '#ffffff' }}
    >
      {track}
    </span>
  );
};

export default TrackBadge;
